const routes = [
    {
        path: '/',
        component: () => import('@/layouts/base.jsx'),
        children: [
            {
                path: '/',
                redirect: '/index',
            },
            {
                path: '/index',
                component: () => import('@/views/index'),
                meta: {
                    title: "广东省建筑材料行业协会团体标准编制管理系统",
                    needLogin:true
                }
            },
            {
                path: '/me',
                component: () => import('@/views/me'),
                meta: {
                    title: "广东省建筑材料行业协会团体标准编制管理系统",
                    needLogin:true
                }
            },
            {
                path: '*',
                component: () => import('@/views/index'),
                meta: {
                    title: '404'
                }
            }
        ],
    },
    {
        path: '/login',
        component: () => import('@/views/login'),
        meta: {
            title: "广东省建筑材料行业协会团体标准编制管理系统",
        }
    },
    {
        path: '/register',
        component: () => import('@/views/register/register.jsx'),
        meta: {
            title: "注册账号",
            needLogin:false
        }
    },
    {
        path: '/register2',
        component: () => import('@/views/register/register2.jsx'),
        meta: {
            title: "完善信息",
            needLogin:false
        }
    },
    {
        path: '/basic',
        component: () => import('@/views/me/basic.jsx'),
        meta: {
            title: "设置",
            needLogin:false
        }
    },
    {
        path: '/show/:id',
        component: () => import('@/views/show'),
        meta: {
            title: "",
            needLogin:true
        }
    }
]

export default routes;